/**
 * Safe localStorage wrappers that handle environments where
 * localStorage is null or unavailable (privacy mode, restricted
 * iframes, SSR, etc.) without throwing.
 */

function isLocalStorageAvailable(): boolean {
  try {
    return typeof localStorage !== "undefined" && localStorage !== null;
  } catch {
    return false;
  }
}

export function safeGetItem(key: string): string | null {
  try {
    if (!isLocalStorageAvailable()) return null;
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetItem(key: string, value: string): void {
  try {
    if (!isLocalStorageAvailable()) return;
    localStorage.setItem(key, value);
  } catch {
    // QuotaExceededError or SecurityError — silently fail
  }
}

export function safeRemoveItem(key: string): void {
  try {
    if (!isLocalStorageAvailable()) return;
    localStorage.removeItem(key);
  } catch {
    // SecurityError — silently fail
  }
}

export function safeLocalStorageKeys(): string[] {
  try {
    if (!isLocalStorageAvailable()) return [];
    return Object.keys(localStorage);
  } catch {
    return [];
  }
}
